import { createContext, useContext } from 'react';

interface ViewportContextType {
    isMobile: boolean;
    isDesktop: boolean;
    width: number;
}

export const MOBILE_BREAKPOINT = 768;

export const ViewportContext = createContext<ViewportContextType>({
    isMobile: window.innerWidth < MOBILE_BREAKPOINT,
    isDesktop: window.innerWidth >= MOBILE_BREAKPOINT,
    width: window.innerWidth,
});

export const useViewport = () => useContext(ViewportContext);
